<template>
  <div class="mt-4">
    <h4>{{ $t("message.checkoutDelivery") }} {{ $t("message.address") }}</h4>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label class="required" for="addressinput">{{ $t("message.streetAddress") }}</label>
        <vue-google-autocomplete
          id="OO_addressinput"
          name="OO_addressinput"
          ref="gAutoComplete"
          :enable-geolocation="true"
          :class="isDeliveryAddressValid ? 'form-control':'form-control invaliddatetime'" 
          @change="setStreetAddress"
          @placechanged="getAddressData"
          @blur="streetAddressOnBlur"
          :country="['au']"
          :disabled="getDeliveryIsLoading"
          :placeholder="getStartTypingPlaceholder"
        />
        <div
          v-if="!isDeliveryAddressValid"
          class="text-danger pt-1"
        >{{ $t("message.streetAddressRequired") }}</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-4">
        <label class="required" for="Postcode">{{ $t("message.postcode") }}</label>
        <input
          v-validate="'required|numeric'"
          id="postInput"
          v-model="editModel.PostalCode"
          name="postcode"
          @change="validatePostcode(editModel.PostalCode)"
          @blur="updateDeliveryAddress();"
          type="text"
          class="form-control"
          :disabled="getDeliveryIsLoading"
        />
        <div class="invalid-feedback">{{ OOErrors.first("postcode") | inputNameLocale("postcode") }}</div>
        <div
          class="text-danger pt-1"
          v-if="!isDeliveryAreaValid"
        >{{ $t("message.deliveryNotAvailableFor") }} {{ editModel.PostalCode }}</div>
      </div>
      <div class="form-group col-sm-4">
        <label class="required" for="Suburb">{{ $t("message.suburb") }}</label>
        <input
          v-validate="'required|min:3'"
          id="Suburb"
          v-model="editModel.CityTown"
          name="suburb"
          type="text"
          @blur="updateDeliveryAddress();"
          class="form-control"
          :disabled="getDeliveryIsLoading"
        />
        <div class="invalid-feedback">{{ OOErrors.first("suburb") | inputNameLocale("suburb") }}</div>
      </div>
      <div class="form-group col-sm-4">
        <label class="required" for="State">{{ $t("message.state") }}</label>
        <select
          v-validate="'required'"
          id="State"
          name="state"
          v-model="editModel.State"
          type="text"
          ref="stateRef"
          @change="updateDeliveryAddress();"
          class="form-control"
          :disabled="getDeliveryIsLoading"
        >
          <option
            v-for="(state, index) in states"
            :key="index"
            :value="state.length > 3 ? '' : state"
            :disabled ="state.length > 3"
          >{{ state }}</option>
        </select>
        <div class="invalid-feedback">{{ OOErrors.first("state") | inputNameLocale("state") }}</div>
      </div>
    </div>
    <div class="form-row" v-if="!isGift">
      <div class="form-group col-md-12">
        <label for="insInput">{{ $t("message.deliveryInstructions") }}</label>
        <input
          id="insInput"
          v-model="editModel.DeliveryInstructions"
          type="text"
          class="form-control"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import shared from "../../../../sharedscripts/shop/Checkout/partials/DeliveryAddress.js";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    VueGoogleAutocomplete
  },
  props: {
    editModel: {
      type: Object,
      default: () => {}
    },
    showEstimate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      address: {
        street_number: "",
        route: "",
        locality: ""
      },

      states: [
        this.$t("message.selectYourstate"),
        "ACT",
        "NSW",
        "NT",
        "QLD",
        "SA",
        "TAS",
        "VIC",
        "WA"
      ],
      isDeliveryAreaValid: true,
      isDeliveryAddressValid: true
    };
  },
  created() {
    this.applyDeliveryAddress({
      address: { ...this.editModel },
      isUpdateDeliverAddress: true
    });
  },
  mounted() {
    
    if (this.editModel && this.editModel.PostalCode) {
      this.validatePostcode(this.editModel.PostalCode);
    }
  },
  updated() {
    if(this.$refs.gAutoComplete)
    {
      this.$refs.gAutoComplete.$refs.autocomplete.autocomplete='none';
    }
    if (this.editModel.StreetAddress) {
      document.getElementById(
        "OO_addressinput"
      ).value = this.editModel.StreetAddress;
    }
  },
  watch: {
    "editModel.StreetAddress": {
      handler: function() {
        if (this.editModel.State) {
          this.updateDeliveryAddress();
        }
        this.validatePostcode(this.editModel.PostalCode);
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      "isGift",
      "selectedCompany",
      "getDeliveryDuration",
      "getDeliveryIsLoading",
      "deliveryFee"
    ]),
    ...shared.computed,
    deliveryDuration() {
      var dt = this.getDeliveryDuration;
      if (dt) {
        var dt2 = dt.plus({ minutes: 10 });
        return dt.toFormat("m") + " - " + dt2.toFormat("m");
      }
      return dt;
    },
    getStartTypingPlaceholder(){
      return this.$t("message.StartTyping");
    }
  },
  methods: {
    ...mapActions(["applyDeliveryAddress"]),
    ...shared.methods,
    updateDeliveryAddress() {
      this.applyDeliveryAddress({
        address: this.editModel,
        isUpdateDeliverAddress: true
      });
    }
  }
};
</script>
